import { useEffect } from 'react';

/**
 * Observes a given element using ResizeObserver.
 *
 * @param element - Element to attach ResizeObserver to
 * @param options - ResizeObserver options. WARNING! If you define the
 *   object in component body, make sure to memoize it.
 * @param observerCallback - ResizeObserver callback. WARNING! If you define
 *   the function in component body, make sure to memoize it.
 * @returns void
 */
export const useResizeObserver = (
  element: Element | undefined,
  options: ResizeObserverOptions | undefined,
  observerCallback: ResizeObserverCallback,
): void => {
  useEffect(() => {
    if (!element || !('ResizeObserver' in globalThis)) {
      return undefined;
    }

    const observer = new ResizeObserver(observerCallback);

    observer.observe(element, options);

    return () => {
      observer.disconnect();
    };
  }, [element, options, observerCallback]);
};
